module.exports = __webpack_public_path__ + "assets/wheel-basic.0495f40a6cbf2f33289f450a29333468.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wheel-basic.png
// module id = 137
// module chunks = 0